<template>
  <v-content>
    <v-card class="d-flex align-center justify-center grey lighten-3" flat tile height="100vh">
      <v-card outlined :width="400">
          <my-toolbar :height="55" :title="'Reset Password'">
            <template #right-controls>
              <router-link to="/login">Sign-in</router-link>
            </template>
          </my-toolbar>
            <v-card-text>
              <v-text-field label="Password" type="password" v-model="password" @input="inputPassword"></v-text-field>
              <v-text-field label="Confirm Password" type="password" v-model="confirmPassword" @input="inputPassword"></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="px-5" depressed color="primary" :disabled="disableSubmit" :loading="loadingSubmit" @click="submitForm">Submit</v-btn>
            </v-card-actions>
      </v-card>
    </v-card>
  </v-content>
</template>

<script>
export default {
    data: () => ({
      password: '',
      confirmPassword: '',
      disableSubmit: true,
      loadingSubmit: false
    }),
    beforeMount(){
        this.validateToken()
    },
    methods: {
        validateToken(){
            let token = this.$route.params.token;
            this.$http.get(`/reset/${token}`)
            .catch(error => {
                this.$toast.open({
                    message: "Invalid User Token",
                    type: "error"
                });
                this.$router.push('/login')
            })
        },
        async submitForm(){
            this.loadingSubmit = true;
            this.disableSubmit = true;
            this.$Progress.start();
            let token = this.$route.params.token;
            try{
                let response = await this.$http.post(`/reset/${token}`, JSON.stringify({
                    token, 
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                }));

                if(response.status === 200){
                    this.$toast.open({
                        message: response.data.msg,
                        type: "success"
                    });
                    this.$Progress.finish();
                }
            }catch(error){
                this.$Progress.fail();
                this.$toast.open({
                    message: error.data.err.msg,
                    type: "error"
                });
            }
            finally{
                this.loadingSubmit = false;
                this.password = "";
                this.confirmPassword = "";
            }
        },
        inputPassword(){
            if(this.password.length && this.confirmPassword){
                this.disableSubmit = false
            }else{
                this.disableSubmit = true
            }
        }
    }
}
</script>